module.exports = __webpack_public_path__ + "montserrat-regular-webfont.15440b3bf781557f437c.woff2";


//////////////////
// WEBPACK FOOTER
// D:/Work-Local/frontend/src/assets/fonts/montserrat-regular-webfont.woff2
// module id = ../../../../../src/assets/fonts/montserrat-regular-webfont.woff2
// module chunks = main